import { boxApply1qmzdb3dh90hg as boxApply } from '../js/coreRuntime.mjs';
import { Char19o2r8palgjof as Char } from '../Char.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CharIteratorClass;
function CharIterator() {
  if (CharIteratorClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
      }
      next_30xa17_k$() {
        return this.nextChar_yvnk6j_k$();
      }
      next_20eer_k$() {
        return new (Char())(this.next_30xa17_k$());
      }
    }
    initMetadataForClass($, 'CharIterator');
    CharIteratorClass = $;
  }
  return CharIteratorClass;
}
var IntIteratorClass;
function IntIterator() {
  if (IntIteratorClass === VOID) {
    class $ {
      next_20eer_k$() {
        return this.nextInt_ujorgc_k$();
      }
    }
    initMetadataForClass($, 'IntIterator');
    IntIteratorClass = $;
  }
  return IntIteratorClass;
}
//region block: exports
export {
  CharIterator as CharIterator2h6gbyxoj1es2,
  IntIterator as IntIteratordtlvcwxsuu5a,
};
//endregion

//# sourceMappingURL=PrimitiveIterators.mjs.map
